import React from 'react';

const PageBreak = React.forwardRef((props, ref) => {
  return (
    <div ref={ref} data-pageBreak="true" {...props}/>
  );
});

export default PageBreak;
